<template>
  <Popup :mobile="isMobile" no-close-button>
    <div class="block-user-wrapper">
      <div class="block-user-container">
        <div class="block-user-profile-image">
          <div class="profile-image-container">
            <span><img :src="userInfo.profileImageUrl" alt="profile-image"/></span>
          </div>
          <span class="user-name">{{ userInfo.userName }}</span>
        </div>
        <div class="actions">
          <b-button v-if="!userInfo.blockedByMe" class="destructive" variant="light">Block</b-button>
          <b-button v-if="userInfo.followedByMe" class="destructive" variant="light" @click="unfollow">Unfollow</b-button>
          <b-button :class="isMobile ? '':'last-button'" variant="light" @click="closePopup">Cancel</b-button>
        </div>
      </div>
    </div>
  </Popup>
</template>
<script>
import Popup from "@/module_social/components/Popup";
import {devicesMixin} from "@/utils/devices";
import {createNamespacedHelpers} from "vuex";
const {
  mapActions: reportActions,
  mapState: reportState,
} = createNamespacedHelpers("social");

export default {
  mixins: [devicesMixin],
  components: {
    Popup,
  },
  props: {
    userInfo: {
      type: Object, default: () => ({
        fullName: 'shahbaj',
        profileImageUrl: 'https://assets.gluedin.io/Profile.png'
      })
    }
  },
  methods: {
    ...reportActions(['unFollowUser']),

    async unfollow() {
      await this.unFollowUser(this.userInfo.userId);
      this.closePopup();
    },
    closePopup() {
      this.$emit("closePopup");
    },
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/style/_social.scss";

.block-user-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-user-container {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 2;
  max-width: $max-width-mobile-post-menu;
  min-width: $min-width-mobile-post-menu;
  vertical-align: baseline;

  .block-user-profile-image {
    display: flex;
    flex-direction: column;
    padding: $spacing-2x $spacing-4x;
    border-radius: $border-radius $border-radius 0 0;
    background-color: $white;

    .profile-image-container {
      margin-bottom: $spacing-4x;
      align-self: center;

      span {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          vertical-align: baseline;
        }
      }
    }

    .user-name {
      line-height: $font-size-4x;
      font-size: $font-size-3x;
      font-weight: 500;
      text-align: center;
      word-wrap: break-word;
      position: relative;
      white-space: pre-line;
      max-width: 100%;
    }
  }

  .actions {
    display: flex;
    flex-direction: column;

    .btn {
      border-top: 1px solid $post-separator;
      border-radius: 0;
      font-weight: 600;
      cursor: pointer;
      font-size: $font-size-4x;
      min-height: $dim-6x;
    }

    .last-button {
      border-bottom: none;
      border-radius: 0 0 $border-radius $border-radius;
    }

    .destructive {
      color: $destructive-color;
    }
  }
}
</style>